<div fxLayout="column" fxFlex>

    <div fxLayout="row" fxFlex>
        <div fxFlex="90" fxLayoutAlign="start center center"
             style="font-family: 'Century Gothic', sans-serif; font-size: 16px;">{{title}}</div>
        <div fxFlex="10" fxLayoutAlign="end center center">
            <div (click)="close()" fxLayoutAlign="center center center" fxFlexAlign="center" style="cursor:pointer;">
                <mat-icon>close</mat-icon>
            </div>
        </div>
    </div>

    <div fxLayout="row" style="margin-top: 20px; margin-bottom: 20px;">
        {{formTitle}}
    </div>

    <div fxLayout="row" style="height: 400px; overflow-y: auto; margin-top: 20px;">
        <mat-table [dataSource]="data.displayForms" matSort fxFlex>

            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                    Αναγνωριστικό εγγραφής
                </mat-header-cell>
                <mat-cell *matCellDef="let form"
                          fxLayoutAlign="center center center"> {{form.id}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="displayName">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center"> Όνομα
                    Παιδιού
                </mat-header-cell>
                <mat-cell *matCellDef="let form"
                          fxLayoutAlign="start center center"> {{form.displayName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="title" >
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center" fxFlex="25"> Τίτλος</mat-header-cell>
                <mat-cell *matCellDef="let form" [matTooltip]="form.title" fxFlex="25"
                          fxLayoutAlign="start center center">{{ form.title | slice:0:60 }}{{form.title.length > 60 ? '...' : ''}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="published_at">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center"> Ημ.
                    δημοσίευσης
                </mat-header-cell>
                <mat-cell *matCellDef="let form"
                          fxLayoutAlign="start center center"> {{form.published_at}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="date_completed">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                    Συμπληρώθηκε
                </mat-header-cell>
                <mat-cell *matCellDef="let form"
                          fxLayoutAlign="start center center"> {{form.date_completed}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="modified_by_displayName">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                    Ενημερώθηκε από
                </mat-header-cell>
                <mat-cell *matCellDef="let form"
                          fxLayoutAlign="start center center"> {{form.modified_by_displayName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="modified_at">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                    Ενημερώθηκε στις
                </mat-header-cell>
                <mat-cell *matCellDef="let form"
                          fxLayoutAlign="start center center"> {{form.modified_at ? form.modified_at : '-'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="center center center">
                    Ενέργειες
                </mat-header-cell>
                <mat-cell *matCellDef="let form">
                    <div fxLayout="row" fxLayoutAlign="center center center">
                        <mat-icon (click)="displayForm(form)">remove_red_eye</mat-icon>
                    </div>
                </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let record; columns:displayColumns"></mat-row>
        </mat-table>
    </div>

</div>
